import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:9000/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  getGames(date = null) {
    const url = date ? `/api/sports/nba/games?date=${date}` : '/api/sports/nba/games/today';
    return apiClient.get(url);
  },
  getBoxScore(gameId) {
    return apiClient.get(`/api/sports/nba/games/${gameId}/boxscore`);
  },
  getInsights(gameId) {
    return apiClient.get(`/api/sports/nba/games/${gameId}/insights`);
  },
};
